import { AppSidebar } from "@/components/admin/app-sidebar"
import { Error } from "@/components/admin/error"
import { Loading } from "@/components/admin/loading"
import { LocalesMenuButton } from "@/components/admin/locales-menu-button"
import { Notification } from "@/components/admin/notification"
import { RefreshButton } from "@/components/admin/refresh-button"
import { ThemeModeToggle } from "@/components/admin/theme-mode-toggle"
import { UserMenu } from "@/components/admin/user-menu"
import { Badge } from "@/components/ui/badge"
import { SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar"
import { cn } from "@/lib/utils"
import { env, version } from "@/lib/utils/client.supabase.conf"
import type { CoreLayoutProps } from "ra-core"
import { ErrorInfo, Suspense, useState } from "react"
import { ErrorBoundary } from "react-error-boundary"
export const Layout = (props: CoreLayoutProps) => {
  const [errorInfo, setErrorInfo] = useState<ErrorInfo | undefined>(undefined)
  const handleError = (_: Error, info: ErrorInfo) => {
    setErrorInfo(info)
  }
  return (
    <SidebarProvider>
      <AppSidebar />
      <main
        className={cn(
          "ml-auto w-full max-w-full",
          "peer-data-[state=collapsed]:w-[calc(100%-var(--sidebar-width-icon)-1rem)]",
          "peer-data-[state=expanded]:w-[calc(100%-var(--sidebar-width))]",
          "sm:transition-[width] sm:duration-200 sm:ease-linear",
          "flex h-svh flex-col",
          "group-data-[scroll-locked=1]/body:h-full",
          "has-[main.fixed-main]:group-data-[scroll-locked=1]/body:h-svh"
        )}
      >
        <header className="flex h-16 md:h-12 shrink-0 items-center gap-2 px-4">
          <SidebarTrigger className="scale-125 sm:scale-100" />
          <div className="flex-1 flex items-center" id="breadcrumb" />
          <Badge className="border-none bg-green-600/10 text-green-600 focus-visible:ring-green-600/20 focus-visible:outline-none dark:bg-green-400/10 dark:text-green-400 dark:focus-visible:ring-green-400/40 [a&]:hover:bg-green-600/5 dark:[a&]:hover:bg-green-400/5">
            <span
              className="size-1.5 rounded-full bg-green-600 dark:bg-green-400"
              aria-hidden="true"
            />
            {`v${version}${env && `-${env}`}`}
          </Badge>
          <LocalesMenuButton />
          <ThemeModeToggle />
          <RefreshButton />
          <UserMenu />
        </header>
        <ErrorBoundary
          onError={handleError}
          fallbackRender={({ error, resetErrorBoundary }) => (
            <Error
              error={error}
              errorInfo={errorInfo}
              resetErrorBoundary={resetErrorBoundary}
            />
          )}
        >
          <Suspense fallback={<Loading />}>
            <div className="flex flex-1 flex-col px-4 ">{props.children}</div>
          </Suspense>
        </ErrorBoundary>
      </main>
      <Notification />
    </SidebarProvider>
  )
}
